/*
export const someGetter = (state) => {}
 */
// const lodash = require('lodash')
import { serializeObject } from '../../utils'
import { USDLRegex } from 'src/utils/validators'
import { lk } from 'src/utils'

export default {
    getAffiliates,
    getAddEditClassOpenState,
    getSelectedInstructors,
    dlStateAbbrev,
    driversLicenseErrorMap,
    scheduleUploadExceptionMap,
    classStatuses,
    classApprovalStatuses
}

function getAffiliates (state) {
  // return state.affiliates
  const regex = new RegExp(state.affiliateFilter.toLowerCase())
  return _.filter(state.affiliates, affiliate => (affiliate && affiliate.AFFILIATE_NAME) ? regex.test(affiliate.AFFILIATE_NAME.toLowerCase()) : false)
}

function getAddEditClassOpenState (state) {
    return state.addEditClassOpenState
}

function getSelectedInstructors (state) {
  let instructors = []
  _.map(state.affiliates, affiliate => {
    _.map(affiliate.INSTRUCTORS, instructor => {
      if (instructor.selected === true) {
        instructors.push({ AID: affiliate.AFFILIATE_ID, UID: instructor.USER_ID })
      }
    })
  })
  return instructors
}

function dlStateAbbrev (state, getters, rootState) {
  let stateAbbrev = null

  try {
    const student = state.sessionInformation.sessions[state.currentSessionIndex].students[state.currentStudentIndex]
    const stateItem = _.filter(rootState.shared.states, item => {
      if (student) {
        return (item.LK_STATE_ID === student.dlState) ? item : null
      }
    })
    stateAbbrev = (stateItem[0]) ? stateItem[0].STATE.trim() : null
  } catch (error) {
    
  }
  return stateAbbrev
}

function driversLicenseErrorMap (state, getters, rootState) {
  return state.sessionInformation.sessions[state.currentSessionIndex].students.map(student => {
    const stateAbbrev = (student.dlState) ? rootState.shared.states[student.dlState - 1].STATE : ''
    return (student.dlState) ? USDLRegex[stateAbbrev].description.join(', ') : ''
  })
}

function scheduleUploadExceptionMap (state) {
  return state.processedRows.map(row => {
    return row.exception
  })
}


function classStatuses(state){
  return _.map(lk.LK_CLASS_STATUS_ID,(s,key)=>{
    return {
      label: _.capitalize(key),
      value: s
    }
  })
}


function classApprovalStatuses(state){
  return _.map(lk.LK_CLASS_APPROVAL_STATUS_ID,(s,key)=>{
    return {
      label: _.capitalize(key),
      value: s
    }
  })
}